var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7338 6H9.26624C7.46235 6 6 7.46237 6 9.26628V26.7337C6 28.5376 7.46235 30 9.26624 30H26.7338C28.5377 30 30 28.5376 30 26.7337V9.26628C30 7.46237 28.5377 6 26.7338 6Z",
    fill: "#081E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1926 26V18.702H21.5512L21.9045 15.8576H19.1926V14.0416C19.1926 13.2179 19.4125 12.657 20.5498 12.657L22 12.6562V10.112C21.749 10.0776 20.8885 10 19.8867 10C17.7962 10 16.3647 11.3254 16.3647 13.7597V15.8573H14V18.7017H16.3647V25.9996H19.1929L19.1926 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.58b96f8bff0137d1f8da0c88670292b6.svg";
export { ForwardRef as ReactComponent };